<div class="faq-menu">
	<div
		class="menu__icon"
		(click)="isFaqMenuOpen = !isFaqMenuOpen"
		(keydown.enter)="isFaqMenuOpen = true"
		(keydown.esc)="isFaqMenuOpen = false"
		tabindex="0"
		freud-tooltip
		[tooltipLabel]="'MENU.HELP_AND_COMUNITY' | translate"
		tooltipPosition="bottom"
	>
		<span class="freud-icon freud-icon-school freud-icon-md"></span>
	</div>
	<overlay [isActive]="isFaqMenuOpen">
		<freud-menu
			class="menu__dropdown"
			#faqmenu
			*ngIf="isFaqMenuOpen"
			[items]="menuItems"
		></freud-menu>
	</overlay>
</div>
